<app-spinner></app-spinner>
<div class="verifier-container">
    <h3 class="Admin-Dashboard px-3">{{ translation.t('officerDashboard', 'title') }}</h3>
    <div class="row px-3">
        <div class="col-lg-3 col-md-6 col-sm-12 col-12" style="cursor: pointer;">
            <mat-card class="example-card" appearance="outlined" [routerLink]="['/sdp/officer/dashboard']">
                <mat-card-header class="common-card-header">
                    <mat-card-title>{{ translation.t('officerDashboard', 'totalComplaints') }}</mat-card-title>
                    <mat-icon><span style="color: #7A7FA1; background-color: none;">insert_chart</span></mat-icon>
                </mat-card-header>
                <mat-card-content>
                    <span class="one">{{total_complaints}}</span>
                </mat-card-content>
                <mat-card-footer class="example-card-footer">
                    <!-- <mat-chip-set aria-label="Chihuahua traits">

                        <mat-chip>charming</mat-chip>
                        <mat-chip>graceful</mat-chip>
                        <mat-chip>sassy</mat-chip>
                    </mat-chip-set> -->

                    <p style="padding-left: 17px;">{{ translation.t('officerDashboard', 'forYourDepartment') }}</p>
                </mat-card-footer>
            </mat-card>
        </div>
        <div class="col-lg-3 col-md-6 col-sm-12 col-12" style="cursor: pointer;">
            <mat-card class="example-card" appearance="outlined" [routerLink]="['/sdp/officer/pending-complaints']">
                <mat-card-header class="common-card-header">
                    <mat-card-title>{{ translation.t('officerDashboard', 'pending') }}
                    </mat-card-title>
                    <mat-icon><span style="color:#B19D0A">schedule</span></mat-icon>
                </mat-card-header>
                <mat-card-content>
                    <span class="one">{{pending_count}}</span>
                </mat-card-content>
                <mat-card-footer class="example-card-footer">
                    <p style="padding-left: 17px;">{{ translation.t('officerDashboard', 'awaitingAction') }}</p>
                </mat-card-footer>
            </mat-card>

        </div>
        <div class="col-lg-3 col-md-6 col-sm-12 col-12">
            <mat-card class="example-card" appearance="outlined" [routerLink]="['/sdp/officer/resolved-complaints']">
                <mat-card-header class="common-card-header">
                    <mat-card-title>{{ translation.t('officerDashboard', 'resolved') }}
                    </mat-card-title>
                    <mat-icon><span style="color: #00A90B">check_circle</span></mat-icon>
                </mat-card-header>
                <mat-card-content>
                    <span class="one">{{resolved_count}}</span>
                </mat-card-content>
                <mat-card-footer class="example-card-footer">
                    <p style="padding-left: 17px;">{{ translation.t('officerDashboard', 'successfullyCompleted') }}</p>
                </mat-card-footer>
            </mat-card>
        </div>
        <div class="col-lg-3 col-md-6 col-sm-12 col-12">
            <mat-card class="example-card" appearance="outlined" [routerLink]="['/sdp/officer/escalated-complaints']">
                <mat-card-header class="common-card-header">
                    <mat-card-title>{{ translation.t('officerDashboard', 'escalated') }}
                    </mat-card-title>
                    <mat-icon><span style="color: #F52525">warning</span></mat-icon>
                </mat-card-header>
                <mat-card-content>
                    <span class="one">{{total_escalated}}</span>
                </mat-card-content>
                <mat-card-footer class="example-card-footer">
                    <p style="padding-left: 17px;">{{ translation.t('officerDashboard', 'elevatedToHigherLevel') }}</p>
                </mat-card-footer>
            </mat-card>
        </div>
    </div>
    <div class="row my-5 px-3">
        <div class="col-12">
            <div class="shadow-wrapper">
                <div>
                    <h2 class="py-3">{{ translation.t('officerDashboard', 'totalComplaints') }}</h2>
                </div>
                <div class="row align-items-center  ">
                    <div class="col-md-3 mb-2 mb-md-0">
                        <input type="text" class="form-control fontAwesome"
                            style="padding: 5px; width: 100% !important;"
                            [(ngModel)]="searchText"
                            (keyup)="applyFilter()" 
                            placeholder="{{ translation.t('officerDashboard', 'search') }}">
                    </div>
                   <div class="col-md-3 mb-2 mb-md-0">
  <ng-select
    [(ngModel)]="selectedZone"
    [items]="uniqueZones"
    [placeholder]="translation.t('adminDashboard', 'allZones')"
    (change)="applyFilter()"
    [clearable]="true"
    [searchable]="true">
  </ng-select>
</div>

<div class="col-md-3">
  <ng-select
    [(ngModel)]="selectedDept"
    [items]="uniqueDepartments"
    [placeholder]="translation.t('adminDashboard', 'selectDepartment')"
    (change)="applyFilter()"
    [clearable]="true"
    [searchable]="true">
  </ng-select>
</div>
                    <div class="col-md-3 d-flex gap-2 mt-2 justify-content-end">
                        <button class="btn px-3" style="background-color: #1D6F42; color: white;" (click)="exportToExcel()">
                           <i class="fa fa-file-excel-o me-1"></i> Excel
                       </button>
                       <button class="btn px-3" style="background-color: #f44336; color: white;" (click)="exportToPDF()">
                           <i class="fa fa-file-pdf-o me-1"></i> PDF
                       </button>
                    </div>
                </div>
                <div *ngIf="complaints.data.length > 0; else noData" style="overflow-x: auto;">
                    <table mat-table [dataSource]="complaints" class="mat-elevation-z8" style="width: 100%;">

                        <!-- ID Column -->
                        <ng-container matColumnDef="id">
                            <th mat-header-cell *matHeaderCellDef>{{ translation.t('officerDashboard', 'srNo') }}</th>
                            <td mat-cell *matCellDef="let element; let i = index">{{ (paginator.pageIndex * paginator.pageSize) + i + 1 }}</td>
                        </ng-container>

                        <!-- Ticket Id Column -->
                        <ng-container matColumnDef="ticket_id">
                            <th mat-header-cell *matHeaderCellDef>{{ translation.t('officerDashboard', 'ticketId') }}</th>
                            <td mat-cell *matCellDef="let element">{{ element.ticket_id }}</td>
                        </ng-container>

                        <!-- Department Column -->
                        <ng-container matColumnDef="department">
                            <th mat-header-cell *matHeaderCellDef>{{ translation.t('officerDashboard', 'department') }}</th>
                            <td mat-cell *matCellDef="let element">{{ element.departments }}</td>
                        </ng-container>

                        <!-- Zone Column -->
                        <ng-container matColumnDef="zone">
                            <th mat-header-cell *matHeaderCellDef>{{ translation.t('preview', 'zone') }}</th>
                            <td mat-cell *matCellDef="let element">{{ element.zone }}</td>
                        </ng-container>

                        <!-- Full Name Column -->
                        <ng-container matColumnDef="fullName">
                            <th mat-header-cell *matHeaderCellDef>{{ translation.t('officerDashboard', 'fullName') }}</th>
                            <td mat-cell *matCellDef="let element">{{ element.full_name }}</td>
                        </ng-container>

                        <!-- Mobile No Column -->
                        <ng-container matColumnDef="mobileNo">
                            <th mat-header-cell *matHeaderCellDef>{{ translation.t('officerDashboard', 'mobileNo') }}</th>
                            <td mat-cell *matCellDef="let element">{{ element.mobile_no }}</td>
                        </ng-container>

                        <!-- Date & Time Column -->
                        <ng-container matColumnDef="dateTime">
                            <th mat-header-cell *matHeaderCellDef>{{ translation.t('officerDashboard', 'createdDate') }}</th>
                            <td mat-cell *matCellDef="let element">{{ element.create_date }}</td>
                        </ng-container>


                        <!-- Days Open Column -->
                        <ng-container matColumnDef="days_open">
                            <th mat-header-cell *matHeaderCellDef>{{ translation.t('common', 'daysOpen') }}</th>
                            <td mat-cell *matCellDef="let element">{{ element.number_of_open_days }}</td>
                        </ng-container>


                        <!-- Status Column -->
                        <ng-container matColumnDef="status">
                            <th mat-header-cell *matHeaderCellDef>{{ translation.t('common', 'status') }}</th>
                            <td mat-cell *matCellDef="let element">{{ element.status}}</td>
                        </ng-container>

                        <!-- Action Column -->
                        <ng-container matColumnDef="action">
                            <th mat-header-cell *matHeaderCellDef>{{ translation.t('common', 'action') }}</th>
                            <td mat-cell *matCellDef="let element; let i = index">
                                <div class="d-flex justify-content-center align-items-center">
                                    <h6 style="color: rgb(0, 26, 255); text-decoration: underline; cursor: pointer;"
                                        class="mt-2 view" (click)="route1(element)"
                                        matTooltip="{{ translation.t('common', 'viewMore') }}">
                                        {{ translation.t('common', 'viewMore') }}
                                    </h6>


                                    <mat-icon style="cursor: pointer; vertical-align: middle; margin-left: 10px; color: rgb(0, 26, 255);" class="more-options-icon"
                                        [matMenuTriggerFor]="menu" matTooltip="{{ translation.t('common', 'moreOptions') }}">
                                        more_vert
                                    </mat-icon>
                                </div>


                                <mat-menu #menu="matMenu">
                                    <!-- <h6 mat-menu-item *ngIf="['PENDING', 'RESOLVED'].includes(element.status)"
                                        (click)="route(element)">
                                        <span
                                            style="color: rgb(134, 134, 135); text-decoration: underline;cursor: pointer; font-size: 14px;">Update</span>
                                    </h6> -->

                                    <h6 mat-menu-item (click)="onDownloadPDF(element)">
                                        <span
                                            style="color: rgb(1, 159, 244); text-decoration: underline;cursor: pointer; font-size: 14px;">{{ translation.t('preview', 'printForm') }}</span>
                                    </h6>
                                </mat-menu>
                            </td>



                        </ng-container>
                        <!-- Table Headers and Rows -->
                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

                    </table>
                </div>
                <div class="paginator-wrapper">
                    <mat-paginator [pageSizeOptions]="[5, 10, 20, 50, 100]" showFirstLastButtons
                        aria-label="Select page of periodic elements">
                    </mat-paginator>
                </div>
            </div>
            <ng-template #noData>
                <div class="text-center my-4 " style="font-size: 18px; color: gray;">
                    {{ translation.t('common', 'recordsNotFound') }}
                </div>
            </ng-template>
        </div>
    </div>

</div>